import apiService from '@/services/apiService'

export default {
  props: {
    value: null
  },
  data() {
    return {
      currentImage: this.value,
      progressCurrent: 0,
      progressTotal: 0
    }
  },
  methods: {
    // fileResize: function(file) {
    //   console.log(file);
    //   let vm = this;
    //   return new Promise((resolve, reject) => {
    //     var reader = new FileReader();
    //     reader.onloadend = function() {
    //       var tempImg = new Image();
    //       tempImg.src = reader.result;
    //       tempImg.onload = function() {
    //         var MAX_WIDTH = 1000;
    //         var MAX_HEIGHT = 1000;
    //         if (vm.outputtype == "base64") {
    //           MAX_WIDTH = 500;
    //           MAX_HEIGHT = 500;
    //         }
    //         var tempW = tempImg.width;
    //         var tempH = tempImg.height;
    //         if (tempW > tempH) {
    //           if (tempW > MAX_WIDTH) {
    //             tempH *= MAX_WIDTH / tempW;
    //             tempW = MAX_WIDTH;
    //           }
    //         } else {
    //           if (tempH > MAX_HEIGHT) {
    //             tempW *= MAX_HEIGHT / tempH;
    //             tempH = MAX_HEIGHT;
    //           }
    //         }

    //         var canvas = document.createElement("canvas");
    //         canvas.width = tempW;
    //         canvas.height = tempH;
    //         var ctx = canvas.getContext("2d");
    //         ctx.drawImage(this, 0, 0, tempW, tempH);
    //         var dataURL = null;
    //         if (file.type == "image/png") {
    //           dataURL = canvas.toDataURL("image/png");
    //         } else {
    //           dataURL = canvas.toDataURL("image/jpeg");
    //         }
    //         var data = "image=" + dataURL;
    //         try {
    //           if (vm.outputtype == "base64") {
    //             vm.$emit("input", dataURL);
    //             vm.currentImage = dataURL;
    //             vm.$emit("onUploaded", dataURL);
    //           }
    //           var obj = vm.dataURItoBlob(data);
    //           obj.name = file.name;
    //           resolve(obj);
    //         } catch (error) {
    //           vm.$swal({
    //             title: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
    //             type: "error",
    //             text: `dataURItoBlob: ${error}`,
    //             confirmButtonText: vm.$t("Confirm"),
    //           });
    //           reject();
    //         }
    //       };
    //     };
    //     reader.readAsDataURL(file);
    //   });
    // },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      // console.log(new Blob([ia], { type: mimeString }));
      return new Blob([ia], { type: mimeString })
    },

    async upload(file, filename = 'untitle') {
      //   return new Promise(async (resolve) => {
      let data = {
        name: filename + '.jpg',
        type: file.type,
        file: file
      }
      try {
        var url = await this.getSignedRequest(data)
        url = encodeURI(url)
        this.currentImage = url
        if (typeof this.value !== 'undefined') {
          this.$emit('input', this.currentImage)
        }
        // this.$emit("onUploaded", this.currentImage);
        return this.currentImage
        // resolve();
      } catch (error) {
        // console.log(error);
      }
      //   });
    },
    async getSignedRequest(data) {
      //   return new Promise(async (resolve) => {
      // let url = "sign-s3-v2?file-name=" + data.name + "&file-type=" + data.type;
      try {
        const business_id = sessionStorage.getItem('businessId')
        var response = await apiService.get('sign-s3', {
          'file-name': data.name,
          'file-type': data.type,
          business_id
        })
        // console.log(response);
        if (response) {
          response.file = data.file
          var res = await this.uploadfile(response)
          return res
          // resolve(res);
        }
      } catch (error) {
        this.$store.dispatch('login/setIsAuthenticated', 'false')
        return error
      }
      //   });
    },
    uploadfile(data) {
      // console.log(data);
      var vm = this
      return new Promise((resolve, reject) => {
        let signedRequest = data.data.signedRequest
        const formData = new FormData()
        formData.append('acl', 'public-read')
        Object.keys(signedRequest.fields).forEach((key) => {
          formData.append(key, signedRequest.fields[key])
        })
        // Actual file has to be appended last.
        formData.append('file', data.file)
        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1]);
        // }
        const xhr = new XMLHttpRequest()
        xhr.open('POST', signedRequest.url, true)
        xhr.upload.onprogress = (event) => {
          // event.loaded returns how many bytes are downloaded
          // event.total returns the total number of bytes
          // event.total is only available if server sends `Content-Length` header
          //   console.log(`Uploaded ${event.loaded} of ${event.total} bytes`);
          vm.progressCurrent = event.loaded
          vm.progressTotal = event.total
        }

        xhr.send(formData)
        xhr.onload = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200 || xhr.status === 204) {
              resolve(data.data.url)
            } else {
              reject('Could not upload file.')
            }
          }
        }
      })
    }
  }
}
